export default __webpack_public_path__ + "static/media/Delete.ff0ccdfb.svg";